import React, { useState } from "react";
import styled from "styled-components";
import { SearchIcon } from "./Icons"; // Assume you have a SearchIcon component

const SearchBox = ({
  width = "100%", // Default width, can be overridden via props
  placeholder = "Search",
  onSearch, // Function to call when the search term changes
  searchFields = [], // Array of field names to search over
  data = [], // The data array to search
}) => {
  const [searchTerm, setSearchTerm] = useState("");

  const handleInputChange = (e) => {
    const term = e.target.value;
    setSearchTerm(term);

    if (onSearch) {
      const filteredData = data.filter((item) =>
        searchFields.some((field) => {
          const fieldValue = item[field];
          if (fieldValue && typeof fieldValue === "string") {
            return fieldValue.toLowerCase().includes(term.toLowerCase());
          }
          return false;
        })
      );
      onSearch(filteredData);
    }
  };

  return (
    <SearchContainer width={width}>
      <IconWrapper>
        <SearchIcon color="#495057" />
      </IconWrapper>
      <Input
        type="text"
        placeholder={placeholder}
        value={searchTerm}
        onChange={handleInputChange}
      />
    </SearchContainer>
  );
};

export default SearchBox;

// Styled Components
const SearchContainer = styled.div`
  position: relative;
  width: ${(props) => props.width};
  box-sizing: border-box;
`;

const IconWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 12px; /* Adjust as needed */
  transform: translateY(-50%);
  pointer-events: none; /* Allows clicks to pass through to the input */
`;

const Input = styled.input`
  width: 100%;
  padding: 12px 12px 12px 40px; /* Left padding accounts for the icon */
  border-radius: 12px;
  border: 1px solid #ced4da;
  outline: none;
  font-size: 16px;
  box-sizing: border-box;
  &:focus {
    border-color: #00396c;
    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.05);
  }
`;
